import React from 'react';
import Link from 'next/link';

import CareerCard from 'components/pages/career/careercard/CareerCard';
import ExploreCareerCard from 'components/pages/career/explorecareercard/ExploreCareerCard';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CareerCoachingBanner from   './CareerCoachingBanner';

import SkillInsightsImage from 'assets/images/pages/resume/skill-insights.png';
import { TickCircle } from 'iconsax-react';

import classes from './AnalyzeData.module.scss';

const AnalyzeData = ({ data = {} }) => {
    const list = (data?.suggested_career_paths || []);

    if (!list.length) {
        return (
            <div className={classes.wrapper}>
                <div className={classes['empty-state']}>
                    <h3>Shape your pharma career path</h3>
                    <p>Based on your experience and skills, we will identify your strongest career matches, skill gaps, and growth opportunities.</p>
                    <div className='d-flex align-items-center justify-content-center gap-3 flex-wrap'>
                        <img src={SkillInsightsImage.src} alt="Skill Insights" />
                        <div className='d-flex flex-column gap-3'>
                            <div className='d-flex align-items-center gap-2'>
                                <TickCircle color='#18BBA8' />
                                Exact fit score for top roles
                            </div>
                            <div className='d-flex align-items-center gap-2'>
                                <TickCircle color='#18BBA8'     />
                                Personalized career paths
                            </div>
                            <div className='d-flex align-items-center gap-2'>
                                <TickCircle color='#18BBA8' />
                                Skill gap insights to level up faster
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={classes.wrapper}>
            <div className={classes['careerpath-suggestions']}>
                <CareerCoachingBanner />
                {list.map(({ career_path: cp, fit_percentage, reason }, index) => (
                    <div className={classes['careerpath-card']} key={index}>
                        <div className='row'>
                            <div className='col-12 col-xl-3 d-flex justify-content-center align-items-center'>
                                <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                    <CircularProgress
                                        variant="determinate"
                                        value={100}
                                        size={150}
                                        sx={{ color: '#e0e0e0', position: 'absolute' }}
                                    />
                                    <CircularProgress
                                        variant="determinate"
                                        value={fit_percentage}
                                        size={150}
                                        sx={{ color: 'primary.main' }}
                                    />
                                    <Box
                                        sx={{
                                            top: 0,
                                            left: 0,
                                            bottom: 0,
                                            right: 0,
                                            position: 'absolute',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Typography
                                            variant="caption"
                                            component="div"
                                            sx={{ color: 'text.secondary', textAlign: 'center' }}
                                        >
                                            <div className={classes['fit-percentage']}>
                                                {fit_percentage}%
                                            </div>
                                            Fit Percentage
                                        </Typography>
                                    </Box>
                                </Box>
                            </div>
                            <div className='col-12 col-xl-5 d-flex flex-column justify-content-center gap-3'>
                                <h3>Why this career path?</h3>
                                <p>{reason}</p>
                            </div>
                            <div className='col-12 col-xl-4 d-flex justify-content-center align-items-center'>
                                <CareerCard data={cp} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AnalyzeData;